import http from "./httpService";
import config from "./config.json";
export const getBlogs = () => {
  return http.get(`${config.vionna_api}/blogs/GetAllBlogs`);
};
export const getSingleBlog = (NewsId) => {
  return http.get(`${config.vionna_api}/blogs/GetBlogDetails/${NewsId}`);
};
